import { useOrderDialogUrlState } from "./hooks/useOrderDialogUrlState"
import { useCreateOrderUser } from "./hooks/useCreateOrderUser"
import { CreateOrderDialog } from "./CreateOrderDialog"

export function CreateOrderDialogHost() {
    const { isOpen, config, closeDialog } = useOrderDialogUrlState()

    const mode = config.mode ?? "create"
    const resetKey = `${mode}:${config.orderId ?? "new"}`

    const { onBehalf, setOnBehalf } = useCreateOrderUser({ mode, resetKey })

    if (!isOpen) return null

    return (
        <CreateOrderDialog
            open={isOpen}
            orderId={config.orderId}
            mode={mode}
            dialogType={config.dialogType}
            activeOrderTab={config.activeOrderTab}
            flowConfig={config.flowConfig}
            onClose={() => closeDialog()}
            isOnBehalfCompleted={onBehalf}
            setIsOnBehalfCompleted={setOnBehalf}
        />
    )
}
